import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';
import './garment-size-standalone.scss';

export default register('garment-size-standalone', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./garment-size-standalone'),
    ),
);
